import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    customeraktif(obj) {
        return new Promise(async (resolve, reject) => {
            try {

                const keys = ['customer_group'];
                let str = '?page=1&limit=1000&blocked=0';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const { data } = await axios.get(`/bakerycustomer${str}`);
                resolve(data.list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    customerdistributionaktif(obj) {
        return new Promise(async (resolve, reject) => {
            try {

                const keys = ['customer_group', 'orderdate'];
                let str = '?page=1&limit=1000&blocked=0';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const { data } = await axios.get(`/bakerycustomer/distributionrequest${str}`);
                resolve(data.list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    supplierprice(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['vendor_id'];
                let str = '?page=1&limit=1000';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const { data } = await axios.get(`/bakerysupplierprice${str}`);
                resolve(data.list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    itemaktif(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['customer_group', 'sortBy'];
                let str = '?page=1&limit=1000&isactive=1&headcategory=BREAD';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const { data } = await axios.get(`/bakeryitem${str}`);
                resolve(data.list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    finditemaktif(itemname) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`bakeryitem/finditemaktif/${itemname}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },

    currency() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/currency/cbo");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`bakeryorder/detail/${obj.pohdrkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    detailrequest(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`bakeryorder/detailrequest/${obj.customer_group}/${obj.tgldelivery}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },

    detailrequestAdd(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`bakeryorder/detailrequestAdd/${obj.customer_group}/${obj.tgldelivery}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },

    pasalpph() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/bakeryorder/pasalpph");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    detailrequestsmry(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['last_vendor_code', 'customer_group'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const {
                    data
                } = await axios.get(`bakeryorder/detailrequestsmry/${obj.tgldelivery}${str}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    detailitemrequestsmry(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir',
                    `itemname`, `itemcode`,
                    'tgldelivery', 'pohdrkey', 'last_vendor_code', 'customer_group'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const {
                    data
                } = await axios.get(`bakeryorder/detailitemrequestsmry/${str}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    detailrequestsmryforcreatepo(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['last_vendor_code', 'customer_group'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const {
                    data
                } = await axios.get(`bakeryorder/detailrequestsmryforcreatepo/${obj.tgldelivery}${str}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    customerdelivery(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir',
                    'tgl1', 'tgl2', 'customer_id'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const {
                    data
                } = await axios.get(`bakeryorder/customer-delivery/${str}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    customerdeliveryorder(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir',
                    'tgl1', 'tgl2', 'customer_id', 'CustName', 'itemno', 'itemname'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const {
                    data
                } = await axios.get(`bakeryorder/customerdeliveryorder/${str}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    exportFcCustomer(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tgl1', 'tgl2', 'customer', 'customer_id'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const resp = await axios({
                    url: `/bakeryorder/forcastcustomerxls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    exportFcVendor(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tgl1', 'tgl2', 'vendor', 'vendor_id'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const resp = await axios({
                    url: `/bakeryorder/forcastvendorxls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    exportxls(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'nomor', 'vendor', 'vendor_id', 'requestno', 'postgroup', 'item', 'status', 'outstand', 'orderwholesale'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const resp = await axios({
                    url: `/bakeryorder/exportxls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    exportxlsTransfer(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'tgl3', 'tgl4', 'nomor', 'vendor', 'CustName', 'customer_group', 'CustTrfInName', 'vendor_id', 'requestno', 'postgroup', 'item', 'itemname', 'itemcategory', 'status', 'outstand'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const resp = await axios({
                    url: `/bakeryorder/exportxlsTransfer${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    exportxlsRequest(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'nomor', 'vendor', 'vendor_id', 'requestno', 'postgroup', 'item', 'customerinfo', 'status', 'outstand'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const resp = await axios({
                    url: `/bakeryorder/exportxlsRequest${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    exportxlsRequestAdd(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'nomor', 'vendor', 'vendor_id', 'requestno', 'postgroup', 'item', 'customerinfo', 'status', 'outstand'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const resp = await axios({
                    url: `/bakeryorder/exportxlsRequestAdd${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    exportxlsRequestHeader(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'nomor', 'vendor', 'vendor_id', 'requestno', 'postgroup', 'item', 'customerinfo', 'status', 'outstand'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const resp = await axios({
                    url: `/bakeryorder/exportxlsRequestHeader${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    exportxlsRequestHeaderAdd(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'nomor', 'vendor', 'vendor_id', 'requestno', 'postgroup', 'item', 'customerinfo', 'status', 'outstand'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const resp = await axios({
                    url: `/bakeryorder/exportxlsRequestHeaderAdd${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    saverequest(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("bakeryorder/request", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    saverequestAdditional(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("bakeryorder/requestAdditional", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("bakeryorder", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    savewholesale(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("bakeryorder/powholesale", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    savereceiving(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("bakeryorder/receiving", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    savereceivingcustomer(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("bakeryorder/receivingcustomer", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },

    listtransfer(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal',
                    'tgl1', 'tgl2', 'tgl3', 'tgl4', 'status', 'CustName', 'customer_group', 'CustTrfInName', 'vendor', 'vendor_id', 'requestno', 'postgroup',
                    'itemname', 'itemcategory', 'status', 'outstand'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/bakeryorder/transfer${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    listrequest(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal',
                    'tgl1', 'tgl2', 'status', 'CustName', 'vendor', 'vendor_id', 'vendorinfo', 'createby', 'requestno', 'postgroup',
                    'itemname', 'status', 'outstand'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/bakeryorder/request${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    listrequestAdd(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal',
                    'tgl1', 'tgl2', 'status', 'CustName', 'vendor', 'vendor_id', 'vendorinfo', 'createby', 'requestno', 'postgroup',
                    'itemname', 'status', 'outstand'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/bakeryorder/requestAdd${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    listrequestheader(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal',
                    'tgl1', 'tgl2', 'status', 'CustName', 'vendor', 'vendor_id', 'vendorinfo', 'createby', 'requestno', 'postgroup',
                    'itemname', 'status', 'outstand'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/bakeryorder/requestheader${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    listrequestheaderAdd(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal',
                    'tgl1', 'tgl2', 'status', 'CustName', 'vendor', 'vendor_id', 'vendorinfo', 'createby', 'requestno', 'postgroup',
                    'itemname', 'status', 'outstand'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/bakeryorder/requestheaderAdd${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    //list header
    listheader(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'status', 'nomor', 'vendor', 'vendor_id', 'requestno', 'postgroup', 'item', 'status', 'outstand', 'orderwholesale'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/bakeryorder/orderheader${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    //list lines
    list(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'status', 'nomor', 'vendor', 'vendor_id', 'requestno', 'postgroup', 'item', 'status', 'outstand', 'orderwholesale'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/bakeryorder/order${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    itemlist(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'status', 'nomor', 'vendor', 'vendor_id', 'requestno', 'postgroup', 'item', 'itemcategory', 'status', 'outstand'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/bakeryorder/itemlist${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                obj.ttlOrder = meta.ttlOrder;
                obj.ttlChecker = meta.ttlChecker;
                obj.ttlDeliver = meta.ttlDeliver;
                obj.ttlReceipt = meta.ttlReceipt;
                obj.ttlRetur = meta.ttlRetur;
                obj.ttlTransferIn = meta.ttlTransferIn;
                obj.ttlTransferOut = meta.ttlTransferOut;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    approval(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("bakeryorder/send2wf", obj, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },

    approvalAdditional(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("bakeryorder/send2wfAdditional", obj, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    cancelapprovalAdditional(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("bakeryorder/send2wfAdditionalCancel", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },

    sendtovendor(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("bakeryorder/sendtovendor", obj, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },

    copy(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("bakeryorder/copy", obj, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },

    generatePO(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("bakeryorder/generatePO", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },

    print(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url;
            let str = '';
            try {
                str = '?key=' + encodeURIComponent(obj.pohdrkey);
                url = `/bakeryorder/print`;

                url += str;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    printdo(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url;
            let str = '';
            try {
                str = '?key=' + encodeURIComponent(obj.pohdrkey);
                url = `/bakeryorder/printdo`;

                url += str;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    printdounsend(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url;
            let str = '';
            try {
                str = '?key=' + encodeURIComponent(obj.pohdrkey);
                url = `/bakeryorder/printdounsend`;

                url += str;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    printdofromtransfer(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url;
            let str = '';
            try {
                //console.log("#obj: ", obj);
                str = '?CustTrfIn_id=' + encodeURIComponent(obj.CustTrfIn_id) + '&tanggal=' + encodeURIComponent(obj.tanggal) + '&transferdate=' + encodeURIComponent(obj.transferdate);
                url = `/bakeryorder/printdofromtransfer`;
                url += str;
                //console.log("#url: ", url);
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    printwholesaleinv(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url;
            let str = '';
            try {
                str = '?key=' + encodeURIComponent(obj.pohdrkey);
                url = `/bakeryorder/printwholesaleinv`;

                url += str;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    removerequest(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.delete(`bakeryorder/request/${obj.requestkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    removerequestAdd(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.delete(`bakeryorder/requestAdd/${obj.additionalkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.delete(`bakeryorder/${obj.pohdrkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    // Save Kiriman Susulan
    saveordercontinue(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("bakeryorder/saveordercontinue", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    listorderwholesalecontinu(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                console.log('listorderwholesalecontinu')
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'status', 'nomor', 'vendor', 'vendor_id', 'requestno', 'postgroup', 'item', 'status', 'outstand'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/bakeryorder/orderwholesalecontinu${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    listinventorystockheader(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal',
                    'tgl1', 'tgl2', 'status', 'customer_group', 'customer_id', 'CustName', 'itemcategory', 'itemno', 'itemname', 'byStock'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/bakeryorder/inventorystockheader${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    listinventorystock(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal',
                    'tgl1', 'tgl2', 'status', 'customer_group', 'customer_id', 'CustName', 'itemcategory', 'itemno', 'itemname', 'byStock'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/bakeryorder/inventorystock${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    exportxlsInventoryStock(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'status', 'customer_group', 'customer_id', 'CustName', 'itemcategory', 'itemno', 'itemname', 'byStock'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const resp = await axios({
                    url: `/bakeryorder/exportxlsInventoryStock${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

};